import { CellProps } from 'react-table';
import { DeliveryRateResponse } from '../types';
import numeral from 'numeral';

export const deliveryRateColumns = [
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Min Distance',
    accessor: 'minDistance',
    Cell: ({ row }: CellProps<DeliveryRateResponse>) => (
      <span>{(row.original.minDistance / 1000).toFixed(2)} km</span>
    ),
  },
  {
    Header: 'Max Distance',
    accessor: 'maxDistance',
    Cell: ({ row }: CellProps<DeliveryRateResponse>) => (
      <span>{(row.original.maxDistance / 1000).toFixed(2)} km</span>
    ),
  },
  {
    Header: 'Min Price',
    accessor: 'minPrice',
    Cell: ({ value }: CellProps<DeliveryRateResponse>) => (
      <span>{`₦${numeral(value as number).format('0,0')}`}</span>
    ),
  },
  {
    Header: 'Max Price',
    accessor: 'maxPrice',
    Cell: ({ value }: CellProps<DeliveryRateResponse>) => (
      <span>{`₦${numeral(value as number).format('0,0')}`}</span>
    ),
  },
  {
    Header: 'Rate',
    accessor: 'rate',
    Cell: ({ value }: CellProps<DeliveryRateResponse>) => (
      <span>{`${value}%`}</span>
    ),
  },
  {
    Header: 'Type',
    accessor: 'rateType',
  },
  {
    Header: 'Rate status',
    accessor: 'isActive',
    Cell: ({ value }: CellProps<DeliveryRateResponse>) => (
      <span>{(value as boolean) ? 'Active' : 'Inactive'}</span>
    ),
  },
  {
    Header: 'Action',
  },
];
